import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from "react-toastify";
import useContests from "../../../../models/contests/useContests";


const ParticipantForm = ({ isOpen, onClose, contestId }) => {
    const { addParticipant, fetchParticipants } = useContests();

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            PaperProps={{
                component: "form",
                onSubmit: async (event) => {
                    event.preventDefault();
                    try {
                        const formData = new FormData(event.currentTarget);
                        const formJson = Object.fromEntries(formData.entries());
                        const response = await addParticipant({
                            name: formJson.name,
                            contest: contestId,
                        });
                        toast.success(`Participante añadido correctamente`);
                        onClose();
                        fetchParticipants(contestId);
                    } catch (e) {
                        toast.error("Error al añadir el participante");
                    }
                },
            }}
        >
            <DialogTitle>Añadir participante</DialogTitle>
            <DialogContent>

                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="name"
                    name="name"
                    label="Nombre del participante"
                    type="text"
                    fullWidth
                    variant="standard"
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="outlined">
                    Cancelar
                </Button>
                <Button type="submit" variant="contained">
                    Añadir
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ParticipantForm;
